import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Link } from 'react-router-dom';

import { addComment } from '@happenings/components/entities/comments/actions';

import Comment from './Comment';
import AddCommentInput from './AddCommentInput';
import Store from '@happenings/components/store';

const NUM_COMMENTS_BELOW_POST = 5;

type OwnProps = {
  postId: number;
};

const mapStateToProps = (state: Store, props: OwnProps) => ({
  currentUser: state.session.currentUser,
  comments: state.entities.comments[ props.postId ]?.comments || [],
  loading: state.ui.loading.commentsLoading,
});

const mapDispatch = {
  addComment,
};

const connector = connect(mapStateToProps, mapDispatch);
type Props = OwnProps & ConnectedProps<typeof connector>;

const PostComments = (props: Props) => {
  const commentHelper = (text: string) => {
    if (!props.currentUser) return;
    props.addComment(props.postId, props.currentUser.id, text);
  };

  const showComment = (comment) => {
    return (
      <Comment
        key={comment.id}
        comment={comment}
        userIsAuthor={
          comment.username === props.currentUser?.username
        }
      />
    );
  };

  return (
    <div>
      {props.comments.slice(-NUM_COMMENTS_BELOW_POST).map(showComment)}
      {props.comments.length > 0 ? (
      <div style={{ textDecoration: 'underline', padding: '10px 0' }}>
        <Link to={`/event/${props.postId}/comments`}>
          {props.comments.length < NUM_COMMENTS_BELOW_POST
            ? `View comments`
            : `View all ${props.comments.length} comments`}
        </Link>
      </div>
      ) : null}
      {props.currentUser ? (
        <AddCommentInput addComment={commentHelper} />
      ) : null}
    </div>
  );
};

export default connector(PostComments);